// The 6 fixed system roles. Strings MUST match the backend exactly (Domain/Constants/RoleNames.cs);
// they arrive verbatim in MeResponse.role and drive client-side nav/guards (UX only — server enforces).

export const ROLES = {
  SystemAdministrator: 'System Administrator',
  CallCenterManager: 'Call Center Manager',
  Supervisor: 'Supervisor',
  QualityControlSpecialist: 'Quality Control Specialist',
  TrainingUser: 'Training User',
  ManagementObserver: 'Management Observer',
} as const;

export type RoleName = (typeof ROLES)[keyof typeof ROLES];

export const ALL_ROLES: RoleName[] = Object.values(ROLES);

/** Persian display labels for each role. */
export const ROLE_LABELS: Record<RoleName, string> = {
  [ROLES.SystemAdministrator]: 'مدیر سیستم',
  [ROLES.CallCenterManager]: 'مدیر مرکز تماس',
  [ROLES.Supervisor]: 'سرپرست',
  [ROLES.QualityControlSpecialist]: 'کارشناس کنترل کیفیت',
  [ROLES.TrainingUser]: 'کاربر آموزش',
  [ROLES.ManagementObserver]: 'ناظر مدیریتی',
};

/** Landing route each role is redirected to after login (architecture §4.2, [ASSUMED] Q1). */
export const ROLE_LANDING: Record<RoleName, string> = {
  [ROLES.SystemAdministrator]: '/admin/users',
  [ROLES.CallCenterManager]: '/dashboard',
  [ROLES.Supervisor]: '/calls',
  [ROLES.QualityControlSpecialist]: '/review-queue',
  [ROLES.TrainingUser]: '/reports/training-cases',
  [ROLES.ManagementObserver]: '/dashboard',
};

export function roleLabel(role: string): string {
  return (ROLE_LABELS as Record<string, string>)[role] ?? role;
}

/** Post-login landing path; falls back to /dashboard for any unrecognized role. */
export function landingFor(role: string): string {
  return (ROLE_LANDING as Record<string, string>)[role] ?? '/dashboard';
}
